import { CALL_API } from "redux-api-middleware";
import { ho } from "apis/homeowner/ho";
import appraisalGaar from "apis/appraisalGaar";
import {
  REQUEST_VALIDATIONISSUES_RESULTS,
  RECEIVE_VALIDATIONISSUES_RESULTS,
  ERROR_VALIDATIONISSUES_RESULTS,
  REQUEST_VALIDATIONSTATUS_RESULTS,
  RECEIVE_VALIDATIONSTATUS_RESULTS,
  ERROR_VALIDATIONSTATUS_RESULTS,
  REQUEST_VEROSPREVIEW_UPDATE,
  RECEIVE_VEROSPREVIEW_UPDATE,
  ERROR_VEROSPREVIEW_UPDATE,
  REQUEST_VEROSSUBMIT_UPDATE,
  RECEIVE_VEROSSUBMIT_UPDATE,
  ERROR_VEROSSUBMIT_UPDATE,
  REQUEST_GAAR_RESULTS,
  RECEIVE_GAAR_RESULTS,
  ERROR_GAAR_RESULTS,
} from "typeConstants";
import responseHandler from "responseHandler";
import { HTTP_GET, HTTP_POST, WebApiReduxRequest } from "tools/webservice";

const getValidationIssues = id => {
  return (dispatch, getState) => {
    let controlNumber;
    if (id !== null && id !== 0) {
      controlNumber = id;
    } else {
      controlNumber = getState().caseForms.caseHeader.caseInfo.controlNumber;
    }
    if (!controlNumber) {
      controlNumber = getState().caseDetails.controlNumber;
      if (!controlNumber) {
        return;
      }
    }

    dispatch({
      [CALL_API]: {
        endpoint: ho.validationIssues(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_VALIDATIONISSUES_RESULTS,
          {
            type: RECEIVE_VALIDATIONISSUES_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_VALIDATIONISSUES_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getValidationStatus = id => {
  return (dispatch, getState) => {
    let controlNumber = (id !== null && id !== 0) ? id : getState().caseForms.caseHeader.caseInfo.controlNumber;
    if (!controlNumber) {
      controlNumber = getState().caseDetails.controlNumber;
      if (!controlNumber) {
        return;
      }
    }

    dispatch({
      [CALL_API]: {
        endpoint: ho.validationStatus(controlNumber),
        method: HTTP_GET,
        types: [
          REQUEST_VALIDATIONSTATUS_RESULTS,
          {
            type: RECEIVE_VALIDATIONSTATUS_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_VALIDATIONSTATUS_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const saveVerosPreview = (id, verosPreview, callback) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.verosPreview(id),
        method: HTTP_POST,
        body: JSON.stringify(verosPreview),
        types: [
          REQUEST_VEROSPREVIEW_UPDATE,
          {
            type: RECEIVE_VEROSPREVIEW_UPDATE,
            payload: (action, state, res) =>
              res.json().then(data => {
                setTimeout(() => {
                  responseHandler.success(
                    "Veros Preview Overrides Updated",
                    dispatch
                  );
                }, 0);
                return data;
              })
          },
          {
            type: ERROR_VEROSPREVIEW_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }).then(callback);
};

const saveVerosSubmit = (id, verosSubmit, callback) => {
  return dispatch =>
    dispatch({
      [CALL_API]: {
        endpoint: ho.verosSubmit(id),
        method: HTTP_POST,
        body: JSON.stringify(verosSubmit),
        types: [
          REQUEST_VEROSSUBMIT_UPDATE,
          {
            type: RECEIVE_VEROSSUBMIT_UPDATE,
            payload: (action, state, res) =>
              res.json().then(data => {
                setTimeout(() => {
                  responseHandler.success(
                    "Veros UCDP Basic Edit Checks Overrides Updated",
                    dispatch
                  );
                }, 0);
                return data;
              })
          },
          {
            type: ERROR_VEROSSUBMIT_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    }).then(callback);
};

const getGaarResults = controlIdNumber =>
  WebApiReduxRequest(
    REQUEST_GAAR_RESULTS,
    RECEIVE_GAAR_RESULTS,
    ERROR_GAAR_RESULTS,
    HTTP_GET,
    appraisalGaar.getResults(controlIdNumber)
  );

export {
  getValidationIssues,
  getValidationStatus,
  saveVerosPreview,
  saveVerosSubmit,
  getGaarResults
};
